/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value6: "",
    value7: "",
    value8: "",
    value9a: "",
    value9: "",
    value10: "",
    value11: "",
    value12: "",
  },
];

export default function TaxPersonalTable05({ formData, setFieldValue, count }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value6: "",
      value7: "",
      value8: "",
      value9a: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => setData((prev) => prev.filter((item) => item.id !== id));

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (id === item.id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">I. VẬT LIỆU, DỤNG CỤ, SẢN PHẨM, HÀNG HÓA</Typography>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={2} style={{ textAlign: "center" }}>
                Vật liệu, dụng cụ, sản phẩm, hàng hóa / Nhóm hàng hóa
                <div className="button-action" style={{ left: "-40px" }}>
                  <button type="button" onClick={handleAdd}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Đơn vị tính của vật liệu, dụng cụ, sản phẩm, hàng hóa
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Số dư đầu kỳ
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Nhập trong kỳ
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Xuất trong kỳ
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Tồn cuối kỳ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số lượng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Thành tiền
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số lượng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Thành tiền
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số lượng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Thành tiền
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số lượng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Thành tiền
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (06)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (07)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (08)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (09)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (10)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (11)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (12)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (13)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (14)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (15)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete" style={{ left: "-40px" }}>
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "left", maxWidth: 100, fontStyle: "italic" }}>
                  <InputTable
                    type="text"
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    type="text"
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value10"
                    value={item.value10}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0,000
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                rowSpan={1}
                colSpan={2}
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: 700 }}
              >
                Tổng cộng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
            </tr>
          </tbody>
        </table>
        <SoftButton style={{ marginTop: 10 }} variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, id });
    } else {
      onChange({ value, name, id });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: !type ? "right" : "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
